module.exports = __webpack_public_path__ + "img/P6.f794e3d2.jpg";